import { Avatar, Button, Label, RadioGroup, RadioGroupItem } from '@chain-zen/ui'

import { useWorkspaceSetup } from '../../contexts/setup-workspace-context'
import { useSetupWorkspaceModal } from '../../stores/setup-workspace-modal-store'
import { CompanyIdentifierEnum } from '../../types/workspace'
import { SetupWorkspaceLayout } from './setup-workspace-layout'

/**
 * This component is used to select the type of identifier for the company - DOT or MC.
 */
export const SelectMCOrDOTType = () => {
  const { setStep, setCompanyIdentifierType, companyIdentifierType } = useWorkspaceSetup()
  const { workspace } = useSetupWorkspaceModal()

  const title = workspace ? (
    <div className="flex items-center my-2">
      <span>{`Let's get`}</span>
      <Avatar
        className="mx-2"
        src={workspace.logo || undefined}
        alt={workspace.displayName || ''}
        name={workspace.displayName || ''}
        variant={'square'}
        size={'xs'}
      />
      <span>{workspace?.displayName} verified!</span>
    </div>
  ) : (
    "Let's get your company verified!"
  )

  return (
    <SetupWorkspaceLayout title={title} subtitle="Pick how you want to get verified.">
      <Label>Select one</Label>
      <RadioGroup
        onValueChange={setCompanyIdentifierType}
        value={companyIdentifierType}
        className="mt-4"
        id="dotOrMC"
        name="dotOrMC"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value={CompanyIdentifierEnum.DOT} id={CompanyIdentifierEnum.DOT} />
          <Label htmlFor="DOT">DOT#</Label>
        </div>
        <div className="flex items-center space-x-2 mt-2">
          <RadioGroupItem value={CompanyIdentifierEnum.MC} id={CompanyIdentifierEnum.MC} />
          <Label htmlFor="MC">MC#</Label>
        </div>
      </RadioGroup>

      {/* Setting the step to 3 will trigger the next step in the setup process which is the MCOrDOTNumber component. */}
      <Button onClick={() => setStep(3)} className="w-full mt-4">
        Next
      </Button>
    </SetupWorkspaceLayout>
  )
}
